const SETUP_ROUTE_BY_INDEX = new Map([
  [0, '/setup/entra'],
  [1, '/setup/timezone'],
  [2, '/setup/vanity'],
  [3, '/setup/mfa'],
  [4, '/setup/appliance'],
  [5, '/setup/bootstrap'],
  [6, '/setup/ai-runner'],
])

const SETUP_STEP_KEY_BY_INDEX = new Map([
  [1, 'timezone'],
  [2, 'vanity_domains'],
  [3, 'mfa_provider'],
  [4, 'appliance_download'],
  [5, 'encryption_bootstrap'],
  [6, 'ai_runner_v2'],
])

export function setupIndexForPath(pathname) {
  for (const [index, path] of SETUP_ROUTE_BY_INDEX) {
    if (pathname === path) return index
  }
  return null
}

export function setupPathForIndex(index) {
  return SETUP_ROUTE_BY_INDEX.get(index) || SETUP_ROUTE_BY_INDEX.get(1)
}

export function firstIncompleteSetupIndex(steps) {
  const states = new Map(steps.map((step) => [step.key, step.status]))
  for (const [index, key] of SETUP_STEP_KEY_BY_INDEX) {
    if (states.get(key) !== 'complete') return index
  }
  return SETUP_STEP_KEY_BY_INDEX.size
}
